"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SafeURL = void 0;
var _joinPathSegments = require("./joinPathSegments");
/**
 * Wrapper around URL that takes into account full path of base URL (which normally URL doesn't do)
 */
class SafeURL extends URL {
  constructor(pathname, base) {
    let baseAsURL;
    if (base !== undefined) {
      baseAsURL = new URL(base);
    }
    super((0, _joinPathSegments.joinPathSegments)(baseAsURL?.pathname, pathname), baseAsURL);
  }
}
exports.SafeURL = SafeURL;
//# sourceMappingURL=SafeURL.js.map